import React, { Component } from 'react';
import { PanelMenu } from 'primereact/panelmenu';
import UserService from '../services/UserService';
import MultilevelSidebar from "react-multilevel-sidebar";
import "react-multilevel-sidebar/src/Sidebar.css";




let options = [];
// let options = [
//   {
//     hideBorder: true,
//     content: [{ id: 1, icon: <i className="fa fa-dashboard"></i>, name: "Dashboard", to: "/dashboard" }]
//   },
//   {
//     hideBorder: true,
//     content: [{
//       id: 2, icon: <i className="fa fa-users"></i>, name: "Masters",
//       children: [
//         {
//           hideBorder: true,
//           content: [{ id: 2.1, name: "User Master", to: "/masters/user-master" }]
//         },
//         {
//           hideBorder: true,
//           content: [{ id: 2.2, name: "Product Master", to: "/masters/product-master" }]
//         },
//         {
//           hideBorder: true,
//           content: [{ id: 2.3, name: "Access Right", to: "/masters/access-right" }]
//         },
//         // {
//         //   hideBorder: true,
//         //   content: [{ id: 2.4, name: "Product Configration", to: "/masters/product-configuration" }]
//         // },
//         // {
//         //   hideBorder: true,
//         //   content: [{ id: 2.6, name: "Sub Category", to: "/masters/category" }]
//         // },
//        {
//         hideBorder: true,
//         content: [{ id: 2.5, name: "Scheme Master", to: "/masters/scheme-master" }]
//       },
//         {
//           hideBorder: true,
//           content: [{ id: 2.7, name: "Dealer Master", to: "/masters/dealer-master" }]
//         },
//         {
//           hideBorder: true,
//           content: [{ id: 2.8, name: "Carton Master", to: "/masters/carton-master" }]
//         },
//         {
//           hideBorder: true,
//           content: [{ id: 2.9, name: "Distributor Master", to: "/masters/distributor-master" }]
//         },
//         {
//           hideBorder: true,
//           content: [{ id: 3.0, name: "List Master", to: "/masters/list-master" }]
//         },
//         {
//           hideBorder: true,
//           content: [{ id: 3.0, name: "Price Master", to: "/masters/price-master" }]
//         }
//       ]
//     }]
//   },
//   {
//     hideBorder: true,
//     content: [{
//       id: 3, icon: <i className="fa fa-users"></i>, name: "Transaction",
//       children: [
//         {
//           hideBorder: true,
//           content: [{ id: 3.1, name: "Issue Number", to: "/transaction/number-issued" }]
//         },
//         {
//           hideBorder: true,
//           content: [{ id: 3.2, name: "Mapping", to: "/transaction/mapping" }]
//         },
//         {
//           hideBorder: true,
//           content: [{ id: 3.3, name: "De Mapping", to: "/transaction/de-mapping" }]
//         },
//         {
//           hideBorder: true,
//           content: [{ id: 3.4, name: "Product Damage", to: "/transaction/product-damage" }]
//         },
//         {
//           hideBorder: true,
//           content: [{ id: 3.5, name: "Scheme Configuration", to: "/transaction/scheme-configuration" }]
//         },
//         {
//           hideBorder: true,
//           content: [{ id: 3.6, name: "Secondary Packing", to: "/transaction/secondary-packing" }]
//         },
//         {
//           hideBorder: true,
//           content: [{ id: 3.7, name: "Tertiary Packing", to: "/transaction/tertiary-packing" }]
//         },
//         {
//           hideBorder: true,
//           content: [{ id: 3.8, name: "Dispatch", to: "/transaction/dispatch" }]
//         }
//       ]
//     }]
//   },
//   {
//     hideBorder: true,
//     content: [{
//       id: 4, icon: <i className="fa fa-bar-chart"></i>, name: "Reports",
//       children: [
//         {
//           hideBorder: true,
//           content: [{ id: 4.1, name: "Verification Report", to: "/reports/verification-report" }]
//         },
//         {
//           hideBorder: true,
//           content: [{ id: 4.2, name: "Feedback Report", to: "/reports/feedback-report" }]
//         },
//         {
//           hideBorder: true,
//           content: [{ id: 4.3, name: "Mapping Report", to: "/reports/mapping-report" }]
//         },
//         {
//           hideBorder: true,
//           content: [{ id: 4.3, name: "Dispatch Report ", to: "/reports/dispatch-report" }]
//         },
//         {
//           hideBorder: true,
//           content: [{ id: 4.3, name: "Primary Packing Report", to: "/reports/primary-packing-report" }]
//         },
//         {
//           hideBorder: true,
//           content: [{ id: 4.3, name: "Secondary Packing Report", to: "/reports/secondary-packing-report" }]
//         }
//       ]
//     }]
//   },
// ];

// Side bar creation
export class Sidebar extends Component {

  constructor() {
    super();

    this.UserService = new UserService();
    this.state = {
      isOpen: true,
      isPersist: false,
      menuItems: [],
      demoMenu: [
        {
          label: 'Dashboard',
          icon: 'fa fa-tachometer',
          url: 'Dashboard'
        },
        {
          label: 'Master',
          icon: 'pi pi-fw pi-pencil',
          items: [
            {
              label: 'User Master',
              icon: 'pi pi-fw pi-align-left',
              url: '/masters/user-master'
            },
            {
              label: 'Company Master',
              icon: 'pi pi-fw pi-align-right',
              url: '/masters/company-master'
            },
            {
              label: 'Center',
              icon: 'pi pi-fw pi-align-center'
            },
            {
              label: 'Justify',
              icon: 'pi pi-fw pi-align-justify'
            },

          ]
        }, {
          label: 'Master',
          icon: 'pi pi-fw pi-pencil',
          items: [
            {
              label: 'Left',
              icon: 'pi pi-fw pi-align-left'
            },
            {
              label: 'Right',
              icon: 'pi pi-fw pi-align-right'
            },
            {
              label: 'Center',
              icon: 'pi pi-fw pi-align-center'
            },
            {
              label: 'Justify',
              icon: 'pi pi-fw pi-align-justify'
            },

          ]
        },
        {
          label: 'Transaction',
          icon: 'pi pi-fw pi-pencil',
          items: [
            {
              label: 'Left',
              icon: 'pi pi-fw pi-align-left'
            },
            {
              label: 'Right',
              icon: 'pi pi-fw pi-align-right'
            },
            {
              label: 'Center',
              icon: 'pi pi-fw pi-align-center'
            },
            {
              label: 'Justify',
              icon: 'pi pi-fw pi-align-justify'
            },

          ]
        },
      ]

    }
  }
  //to handle sidebar toggle
  handleSidebarToggle = isOpen => {
    this.setState({ isOpen });
  };
  //trigger api function on page call
  componentDidMount() {
    this.getMenu();
  }

  // get Menu by User
  getMenu() {
    this.UserService.getUserMenu().then(data => {
      let childcheck = [];
      //if ResponseCode is 200
      if (data.data.ResponseCode === "200") {
        const arraydata = data.data.ResponseData;
        let arryFinal = [];
        //if arraydata not null
        if (arraydata != null)
          arraydata.forEach(function (par) {
            let contents = [];
            let parent = {}

            parent.hideBorder = par.hideBorder;

            let parentdata = par.content;
            //if parentdata not null
            if (parentdata != null && parentdata.length > 0) {

              parentdata.forEach(function (_parent) {

                let obj = {};
                obj.id = _parent.id;
                obj.icon = <i className={_parent.icon}></i>;
                obj.name = _parent.name;
                obj.to = _parent.to;
                //if _parent.children not null
                if (_parent.children != null && _parent.children.length > 0) {
                  const childdata = _parent.children;
                  obj.children = childdata;


                  //check page permission //
                  childdata.forEach(function (chld) {

                    childcheck.push(chld.content[0].to);

                  });
                  //End check page permission //

                }
                contents.push(obj);
              });
            }
            parent.content = contents;
            arryFinal.push(parent);
          });
        this.setState({
          menuItems: arryFinal
        });

        //if window.location.pathname not valid
        if (childcheck.find(x => x === window.location.pathname) === undefined && window.location.pathname != "/dashboard" && window.location.pathname != "/profile" && window.location.pathname != "/change-password") {
          sessionStorage.removeItem("LoggedInUser");
          sessionStorage.removeItem("refreshToken");
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("userType");
          sessionStorage.removeItem("wareHouseId");
          window.location = '/login'
        }
      }
      else {
        sessionStorage.removeItem("LoggedInUser");
        sessionStorage.removeItem("refreshToken");
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("userType");
        sessionStorage.removeItem("wareHouseId");

        window.location = '/login'
      }

    });
  }

  stripUndefined(arr) {
    return arr.reduce(function (result, item) {
      result.push(Array.isArray(item) && !item.length ? this.stripUndefined(item) : item);
      return result;
    }, []);
  }

  // Return HTML of Side bar

  render() {
    const menuItems = this.state.menuItems;

    //     const sidebarMenu = menuItems.map((items, key) => {
    //     const subMenu = items.items;
    //     <li key={key}><a>{items.label}</a>
    //     {/* {subMenu.map((subItem, key) => <li>
    //         {subMenu.label}
    //     </li>)} */}
    //     </li>
    // })

    return (
      <div className="sidebar-wraper">
        <MultilevelSidebar
          open={this.state.isOpen}
          onToggle={this.handleSidebarToggle}
          options={menuItems}
          persist={this.state.isPersist}
        />
        {/* using in our button to open the sidebar */}
        {/* <button onClick={() => this.handleSidebarToggle(true)}>open</button> */}
        <ul>
          {/* {sidebarMenu} */}
        </ul>
        {/* <PanelMenu model={this.state.demoMenu} /> */}
      </div>
    );
  }
}

export default Sidebar